'use strict';

var _classCallCheck = require("C:\\X\\180729_PROGRAMMER\\190527-reddit-clone\\node_modules\\@babel\\runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var UserList = function UserList(options, _r) {
  _classCallCheck(this, UserList);

  return options.children.map(function (user) {
    return _r._newObject('RedditUser', user);
  });
};

exports.default = UserList;